import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class CharityService {

  getCharity(charity_id) {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/charity/api/v1/charity/" + charity_id,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      } 
      else
        return error.response
    });
  }

  listCharities(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/charity/api/v1/charities",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  deleteCharities(ids) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/charity/api/v1/delete_charities",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        ids: ids
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setCharity(data) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/charity/api/v1/charity",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        charity: data
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

}
